/* es-3d v1 2026-10-14: preventivo istantaneo da STL/3MF, anteprima 3D (three.js da jsDelivr), invio al modulo custom dell'OS. */
(function(){
  var root=document.querySelector('.es3'); if(!root||root.dataset.on) return; root.dataset.on='1';
  var T=JSON.parse(root.querySelector('[data-es3-t]').textContent), CFG=JSON.parse(root.querySelector('[data-es3-cfg]').textContent);
  var EP=root.dataset.endpoint, LANG=root.dataset.lang, P=CFG.p;
  var MATN=T.mat_names.split('|'), COLN=T.col_names.split('|');
  var $=function(s,el){return (el||root).querySelector(s);}, $$=function(s,el){return [].slice.call((el||root).querySelectorAll(s));};
  var nf=new Intl.NumberFormat(LANG==='en'?'en-GB':LANG,{style:'currency',currency:'EUR'});
  var n1=function(x,d){return new Intl.NumberFormat(LANG==='en'?'en-GB':LANG,{maximumFractionDigits:d==null?1:d}).format(x);};

  // nomi tradotti: materiali, galleria
  $$('[data-matname]').forEach(function(h){ h.textContent=MATN[+h.dataset.matname]; });
  $$('[data-matopt]').forEach(function(o){ o.textContent=MATN[+o.dataset.matopt]; o.value=MATN[+o.dataset.matopt]; });
  $$('.es3__gc').forEach(function(c){ c.querySelector('[data-gname]').textContent=c.dataset[LANG]||c.dataset.en; });
  $$('.es3__sc').forEach(function(c){ c.querySelector('[data-gname]').textContent=c.dataset[LANG]||c.dataset.en; });
  (function(){ var v=$('[data-slider]'); if(!v) return; var stop=false, acc=0, down=false, x0=0, s0=0;
    if(matchMedia('(prefers-reduced-motion: reduce)').matches) stop=true;
    v.addEventListener('mouseenter',function(){stop=true}); v.addEventListener('mouseleave',function(){stop=false;down=false});
    v.addEventListener('touchstart',function(){stop=true},{passive:true}); v.addEventListener('touchend',function(){setTimeout(function(){stop=false},2500)},{passive:true});
    v.addEventListener('mousedown',function(e){down=true;x0=e.pageX;s0=v.scrollLeft;v.style.cursor='grabbing'});
    window.addEventListener('mouseup',function(){down=false;v.style.cursor=''});
    v.addEventListener('mousemove',function(e){ if(down){ v.scrollLeft=s0-(e.pageX-x0); } });
    function step(){ var half=v.scrollWidth/2; if(!stop&&half>v.clientWidth){ acc+=.5; if(acc>=1){ v.scrollLeft+=Math.floor(acc); acc-=Math.floor(acc); } if(v.scrollLeft>=half) v.scrollLeft-=half; } requestAnimationFrame(step); }
    requestAnimationFrame(step); })();

  // schede
  function tab(t){
    $$('[data-tab]').forEach(function(b){ b.classList.toggle('is-on',b.dataset.tab===t); b.setAttribute('aria-selected',b.dataset.tab===t); });
    $$('[data-pane]').forEach(function(p){ p.hidden=p.dataset.pane!==t; });
  }
  $$('[data-tab]').forEach(function(b){ b.addEventListener('click',function(){ tab(b.dataset.tab); }); });
  $$('[data-go]').forEach(function(a){ a.addEventListener('click',function(){ tab(a.dataset.go); }); });

  // galleria: filtri e "ne voglio uno simile"
  $$('.es3__chip').forEach(function(c){ c.addEventListener('click',function(){
    $$('.es3__chip').forEach(function(x){ x.classList.toggle('is-on',x===c); });
    $$('.es3__gc').forEach(function(g){ g.hidden=c.dataset.f!=='all'&&g.dataset.cat!==c.dataset.f; });
  }); });
  $$('[data-like]').forEach(function(b){ b.addEventListener('click',function(){
    var g=b.closest('.es3__gc'); tab('nofile');
    var i=$('[data-form="nofile"] input[name="prodotto"]'); i.value=g.querySelector('[data-gname]').textContent;
    $('#es3-conf').scrollIntoView({behavior:'smooth',block:'start'});
    setTimeout(function(){ i.focus({preventScroll:true}); },600);
  }); });

  // ---------- configuratore ----------
  var st={mat:CFG.def,col:1,q:'std',inf:'std',qty:1,unit:1,scale:100,geo:null,file:null};
  var mats=$('[data-mats]'), cols=$('[data-cols]');
  CFG.mat.forEach(function(m,i){
    var b=document.createElement('button'); b.type='button'; b.dataset.m=m.id;
    b.innerHTML='<b></b><span></span>'; b.querySelector('b').textContent=MATN[i]; b.querySelector('span').textContent=nf.format(m.eg*100*P.ric).replace(/,00|\.00/,'')+' / 100 g';
    b.addEventListener('click',function(){ st.mat=m.id; if(m.cols.indexOf(st.col)<0) st.col=m.cols[0]; drawOpts(); calc(); paint(); });
    mats.appendChild(b);
  });
  function M(){ return CFG.mat.filter(function(m){return m.id===st.mat;})[0]; }
  function drawOpts(){
    $$('button',mats).forEach(function(b){ b.classList.toggle('is-on',b.dataset.m===st.mat); });
    cols.innerHTML='';
    M().cols.forEach(function(c){
      var b=document.createElement('button'); b.type='button'; b.style.background=CFG.col[c]; b.title=COLN[c]; b.setAttribute('aria-label',COLN[c]);
      b.classList.toggle('is-on',c===st.col);
      b.addEventListener('click',function(){ st.col=c; drawOpts(); paint(); });
      cols.appendChild(b);
    });
    $('[data-colname]').textContent='· '+COLN[st.col];
  }
  $$('[data-seg]').forEach(function(s){ $$('button',s).forEach(function(b){ b.addEventListener('click',function(){
    $$('button',s).forEach(function(x){ x.classList.toggle('is-on',x===b); }); st[s.dataset.seg]=b.dataset.v; calc();
  }); }); });
  var qty=$('[data-qty]');
  $$('[data-q]').forEach(function(b){ b.addEventListener('click',function(){ qty.value=Math.max(1,Math.min(500,(+qty.value||1)+(+b.dataset.q))); st.qty=+qty.value; calc(); }); });
  qty.addEventListener('input',function(){ st.qty=Math.max(1,Math.min(500,+qty.value||1)); calc(); });
  $('[data-unit]').addEventListener('change',function(e){ st.unit=+e.target.value; calc(); fit(); });
  $('[data-scale]').addEventListener('input',function(e){ st.scale=Math.max(10,Math.min(400,+e.target.value||100)); calc(); fit(); });
  drawOpts();

  function k(){ return st.unit*st.scale/100; } // fattore lineare verso mm
  function calc(){
    if(!st.geo) return;
    var f=k(), vol=st.geo.vol*f*f*f/1000, area=st.geo.area*f*f/100; // cm3, cm2
    var dims=st.geo.dims.map(function(x){return x*f;});
    var m=M(), shell=Math.min(vol,area*P.parete), core=Math.max(0,vol-shell);
    var g=(shell+core*P.riemp[st.inf])*m.rho*P.scarto;
    var h=g/m.gh*(st.q==='fine'?P.fine:1)+P.extra_h;
    var each=(g*m.eg+h*P.ora)*P.ric, disc=0;
    P.sconti.forEach(function(s){ if(st.qty>=s[0]) disc=s[1]; });
    var tot=Math.max(m.min,Math.ceil(P.setup+each*st.qty*(1-disc))-0.1);
    st.out={g:g,h:h,tot:tot,disc:disc,vol:vol,dims:dims};
    $('[data-s="dims"]').textContent=dims.map(function(x){return n1(x,0);}).join(' × ')+' mm';
    $('[data-s="vol"]').textContent=n1(vol)+' cm³';
    $('[data-s="g"]').textContent=n1(g,0)+' g';
    var hh=h*st.qty; $('[data-s="h"]').textContent=hh<1?Math.round(hh*60)+' '+T.min:n1(hh)+' '+T.hours;
    $('[data-p="tot"]').textContent=nf.format(tot);
    $('[data-p="each"]').textContent=st.qty>1?nf.format(tot/st.qty)+' '+T.p_each:'';
    var d=$('[data-p="disc"]'); d.hidden=!disc; d.textContent=T.p_disc+' -'+Math.round(disc*100)+'%';
    $('[data-p="min"]').textContent=T.p_min.replace('[m]',nf.format(m.min));
    var bed=P.piano.slice().sort(function(a,b){return b-a;}), s=dims.slice().sort(function(a,b){return b-a;});
    $('[data-big]').hidden=!(s[0]>bed[0]||s[1]>bed[1]||s[2]>bed[2]);
    $('[data-tiny]').hidden=!(s[0]<4);
  }

  // ---------- lettura file e anteprima 3D ----------
  var V='0.160.0', CDN='https://cdn.jsdelivr.net/npm/three@'+V, three=null;
  function load3(){
    if(three) return three;
    // niente import() qui: il minificatore di Shopify lo riscrive in require. Uno script module iniettato resta intatto.
    three=new Promise(function(ok,ko){
      var id='es3m'+Date.now(), sc=document.createElement('script'); sc.type='module';
      sc.textContent='import * as T from "'+CDN+'/+esm";import {STLLoader} from "'+CDN+'/examples/jsm/loaders/STLLoader.js/+esm";'+
        'import {ThreeMFLoader} from "'+CDN+'/examples/jsm/loaders/3MFLoader.js/+esm";import {OrbitControls} from "'+CDN+'/examples/jsm/controls/OrbitControls.js/+esm";'+
        'window["'+id+'"]({T:T,STL:STLLoader,MF:ThreeMFLoader,OC:OrbitControls});';
      window[id]=function(m){ delete window[id]; ok(m); };
      sc.onerror=ko; setTimeout(function(){ if(window[id]){ three=null; ko(new Error('three non caricato')); } },30000);
      document.head.appendChild(sc);
    });
    return three;
  }
  var drop=$('[data-drop]'), input=$('[data-file]'), msg=$('[data-msg]'), studio=$('[data-studio]');
  function say(t,err){ msg.hidden=!t; msg.textContent=t||''; msg.classList.toggle('is-err',!!err); }
  $('[data-pick]').addEventListener('click',function(e){ e.stopPropagation(); input.click(); });
  drop.addEventListener('click',function(){ input.click(); });
  $('[data-change]').addEventListener('click',function(){ input.click(); });
  ['dragenter','dragover'].forEach(function(ev){ drop.addEventListener(ev,function(e){ e.preventDefault(); drop.classList.add('is-over'); }); });
  ['dragleave','drop'].forEach(function(ev){ drop.addEventListener(ev,function(e){ e.preventDefault(); drop.classList.remove('is-over'); }); });
  drop.addEventListener('drop',function(e){ if(e.dataTransfer&&e.dataTransfer.files[0]) take(e.dataTransfer.files[0]); });
  input.addEventListener('change',function(){ if(input.files[0]) take(input.files[0]); input.value=''; });

  function take(file){
    var ext=(file.name.split('.').pop()||'').toLowerCase();
    if(file.size>25*1024*1024){ say(T.err_size,true); return; }
    st.file=file;
    if(ext!=='stl'&&ext!=='3mf'){ // STEP, OBJ, ZIP: solo invio, preventivo a mano
      st.geo=null; studio.hidden=true; say(T.manual); openForm(); return;
    }
    say(T.reading);
    Promise.all([load3(),file.arrayBuffer()]).then(function(r){
      var L=r[0], buf=r[1], geo;
      if(ext==='stl'){ geo=new L.STL().parse(buf); }
      else {
        var grp=new L.MF().parse(buf), parts=[]; grp.updateMatrixWorld(true);
        grp.traverse(function(o){ if(o.isMesh){ var g=o.geometry.clone(); g.applyMatrix4(o.matrixWorld); parts.push(g.index?g.toNonIndexed():g); } });
        if(!parts.length) throw new Error('vuoto');
        var n=0; parts.forEach(function(g){ n+=g.attributes.position.array.length; });
        var arr=new Float32Array(n), o=0; parts.forEach(function(g){ arr.set(g.attributes.position.array,o); o+=g.attributes.position.array.length; });
        geo=new L.T.BufferGeometry(); geo.setAttribute('position',new L.T.BufferAttribute(arr,3));
      }
      if(geo.index) geo=geo.toNonIndexed();
      var p=geo.attributes.position.array, vol=0, area=0;
      for(var i=0;i<p.length;i+=9){
        var ax=p[i],ay=p[i+1],az=p[i+2],bx=p[i+3],by=p[i+4],bz=p[i+5],cx=p[i+6],cy=p[i+7],cz=p[i+8];
        vol+=ax*(by*cz-bz*cy)-ay*(bx*cz-bz*cx)+az*(bx*cy-by*cx);
        var ux=bx-ax,uy=by-ay,uz=bz-az,vx=cx-ax,vy=cy-ay,vz=cz-az;
        var nx=uy*vz-uz*vy,ny=uz*vx-ux*vz,nz=ux*vy-uy*vx; area+=Math.sqrt(nx*nx+ny*ny+nz*nz)/2;
      }
      geo.computeBoundingBox(); var s=new L.T.Vector3(); geo.boundingBox.getSize(s);
      if(!(Math.abs(vol)>0)) throw new Error('vuoto');
      st.geo={vol:Math.abs(vol)/6,area:area,dims:[s.x,s.y,s.z]};
      say(''); studio.hidden=false; $('[data-fname]').textContent=file.name;
      // file molto piccoli: probabilmente in centimetri o pollici
      st.unit=1; $('[data-unit]').value='1';
      view(L,geo); calc(); drop.hidden=true;
    }).catch(function(e){ try{console.warn('es3 lettura file',e);}catch(x){} st.geo=null; studio.hidden=true; say(T.err_read,true); });
  }

  var R=null;
  function view(L,geo){
    var box=$('[data-canvas]'), THREE=L.T;
    if(!R){
      var r=new THREE.WebGLRenderer({antialias:true,alpha:true}); r.setPixelRatio(Math.min(2,window.devicePixelRatio||1));
      r.outputColorSpace=THREE.SRGBColorSpace; r.toneMapping=THREE.ACESFilmicToneMapping;
      box.insertBefore(r.domElement,box.firstChild);
      var sc=new THREE.Scene(), cam=new THREE.PerspectiveCamera(30,4/3,0.1,1e5);
      sc.add(new THREE.HemisphereLight(0xffffff,0xb8c0cc,1.6));
      var d1=new THREE.DirectionalLight(0xffffff,1.8); d1.position.set(-2,4,3); sc.add(d1);
      var d2=new THREE.DirectionalLight(0xffffff,.6); d2.position.set(3,1,-2); sc.add(d2);
      var oc=new L.OC(cam,r.domElement); oc.enableDamping=true; oc.autoRotate=true; oc.autoRotateSpeed=1.6; oc.enablePan=false;
      oc.addEventListener('start',function(){ oc.autoRotate=false; });
      var mat=new THREE.MeshStandardMaterial({roughness:.55,metalness:0});
      R={r:r,sc:sc,cam:cam,oc:oc,mat:mat,mesh:null,THREE:THREE};
      function size(){ var w=box.clientWidth,h=box.clientHeight; r.setSize(w,h,false); cam.aspect=w/h; cam.updateProjectionMatrix(); }
      size(); window.addEventListener('resize',size);
      (function loop(){ requestAnimationFrame(loop); if(!box.offsetParent) return; oc.update(); r.render(sc,cam); })();
    }
    if(R.mesh){ R.sc.remove(R.mesh); R.mesh.geometry.dispose(); }
    geo.computeVertexNormals(); geo.center();
    R.mesh=new THREE.Mesh(geo,R.mat); R.mesh.rotation.x=-Math.PI/2; R.sc.add(R.mesh);
    paint(); fit();
  }
  function fit(){
    if(!R||!R.mesh) return;
    var b=new R.THREE.Box3().setFromObject(R.mesh), s=b.getSize(new R.THREE.Vector3()).length();
    R.cam.position.set(s*.9,s*.7,s*1.1); R.cam.near=s/100; R.cam.far=s*100; R.cam.updateProjectionMatrix(); R.oc.target.set(0,0,0); R.oc.update();
  }
  function paint(){ if(R) R.mat.color.set(CFG.col[st.col]); }

  // ---------- invio ----------
  function post(path,body){
    return fetch(EP+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
      .then(function(r){ return r.json().catch(function(){return {};}).then(function(j){ if(!r.ok) throw new Error(j.errore||''); return j; }); });
  }
  function upload(file){
    var nome=file.name; if(/\.(3mf|obj)$/i.test(nome)) nome+='.zip'; // il bucket accetta zip; il 3MF e' gia' uno zip
    return post('allegato',{nome:nome,dimensione:file.size}).then(function(j){
      return fetch(j.url,{method:'PUT',headers:{'Content-Type':file.type||'application/octet-stream'},body:file})
        .then(function(r){ if(!r.ok) throw new Error(T.f_err); return j.percorso; });
    });
  }
  var ff=$('[data-form="file"]');
  function openForm(){ ff.hidden=false; setTimeout(function(){ ff.scrollIntoView({behavior:'smooth',block:'start'}); },60); }
  $('[data-order]').addEventListener('click',openForm);

  function invia(f,files,campi,riassunto,evento){
    var m=f.querySelector('[data-fmsg]'), btn=f.querySelector('[data-send]'), lbl=btn.textContent;
    function fail(e){ m.hidden=false; m.className='es3__msg is-err'; m.textContent=(e&&e.message)||T.f_err; btn.disabled=false; btn.textContent=lbl; }
    m.hidden=true;
    if(!f.checkValidity()){ f.reportValidity(); return; }
    btn.disabled=true;
    var paths=[], seq=Promise.resolve();
    files.forEach(function(x,i){ seq=seq.then(function(){ btn.textContent=T.f_uploading+' '+(i+1)+'/'+files.length; return upload(x).then(function(p){ paths.push(p); }); }); });
    seq.then(function(){
      btn.textContent=T.f_sending;
      var d=new FormData(f);
      campi.nome=String(d.get('nome')||'').trim(); campi.cognome=String(d.get('cognome')||'').trim();
      campi.email=String(d.get('email')||'').trim(); campi.telefono=String(d.get('telefono')||'').trim();
      campi.azienda=T.privato; campi.aree=T.area; campi.allegati=paths; campi.messaggio=riassunto(d);
      return post('invio',{modulo:'stampa3d',campi:campi,lingua:LANG,pagina:location.pathname,trappola:String(d.get('trappola')||'')});
    }).then(function(){
      f.classList.add('is-done'); f.querySelector('.es3__done').hidden=false; f.scrollIntoView({behavior:'smooth',block:'center'});
      try{(window.dataLayer=window.dataLayer||[]).push({event:'form_submit',form:evento});}catch(e){}
    }).catch(fail);
  }

  ff.addEventListener('submit',function(e){
    e.preventDefault();
    var o=st.out, mi=CFG.mat.map(function(m){return m.id;}).indexOf(st.mat);
    invia(ff,st.file?[st.file]:[],{
      prodotto:'Stampa 3D da file: '+(st.file?st.file.name:''),
      quantita:String(st.qty),
      finitura:MATN[mi]+', '+COLN[st.col]+', qualita\' '+st.q+', robustezza '+st.inf
    },function(d){
      var r=['ORDINE DI STAMPA 3D (preventivo istantaneo dal sito)','File: '+(st.file?st.file.name:'-')];
      if(o&&st.geo){
        r.push('Materiale: '+MATN[mi]+' | Colore: '+COLN[st.col]+' | Qualita\': '+st.q+' | Robustezza: '+st.inf+' | Quantita\': '+st.qty,
          'Unita\' file: '+(st.unit===1?'mm':st.unit===10?'cm':'pollici')+' | Scala: '+st.scale+'%',
          'Ingombro: '+o.dims.map(function(x){return x.toFixed(1);}).join(' x ')+' mm | Volume: '+o.vol.toFixed(1)+' cm3',
          'Peso stimato: '+o.g.toFixed(0)+' g a pezzo | Tempo stimato: '+(o.h*st.qty).toFixed(1)+' h',
          'PREZZO MOSTRATO AL CLIENTE: '+o.tot.toFixed(2)+' EUR IVA incl.'+(o.disc?' (sconto quantita\' '+Math.round(o.disc*100)+'%)':''));
      } else r.push('Formato non leggibile nel browser: preventivo da fare a mano.');
      var n=String(d.get('note')||'').trim(); if(n) r.push('','Note del cliente:',n);
      return r.join('\n');
    },'stampa3d_file');
  });

  // ---------- "lo disegnate voi" ----------
  var nff=$('[data-form="nofile"]'), ph=$('[data-photos]'), pl=$('[data-plist]'), pfiles=[];
  var OKP=/\.(pdf|jpe?g|png|heic|webp|dwg|dxf|step|stp|stl|zip)$/i;
  function drawP(){
    pl.innerHTML='';
    pfiles.forEach(function(x,i){ var li=document.createElement('li'); li.innerHTML='<span></span><button type="button"></button>';
      li.querySelector('span').textContent=x.name; var b=li.querySelector('button'); b.textContent=T.remove; b.onclick=function(){ pfiles.splice(i,1); drawP(); }; pl.appendChild(li); });
  }
  // sei caselle, una per vista: la foto del cliente prende il posto del render
  var SLUG=['sopra','davanti','destra','dietro','sinistra','sotto'], sfiles=[null,null,null,null,null,null];
  [].forEach.call(root.querySelectorAll('[data-slot]'),function(el){
    var i=+el.getAttribute('data-slot'), inp=el.querySelector('[data-sf]'), ph=el.querySelector('[data-sph]'), df=el.querySelector('[data-sdef]'), sc=el.querySelector('[data-sc] span');
    inp.addEventListener('change',function(){
      var x=inp.files&&inp.files[0]; inp.value='';
      if(!x||!OKP.test(x.name)||!(x.size>0)||x.size>25*1024*1024) return;
      sfiles[i]=x; el.classList.add('is-on'); sc.textContent=T.ph_change;
      if(ph.src) URL.revokeObjectURL(ph.src);
      ph.onerror=function(){ ph.hidden=true; df.hidden=false; };   // HEIC fuori da Safari: niente anteprima, resta il render
      ph.src=URL.createObjectURL(x); ph.hidden=false; df.hidden=true;
    });
  });
  function addP(fl){ [].slice.call(fl).forEach(function(x){ if(pfiles.length<6&&OKP.test(x.name)&&x.size>0&&x.size<=25*1024*1024) pfiles.push(x); }); drawP(); }
  $('[data-ppick]').addEventListener('click',function(){ ph.click(); });
  ph.addEventListener('change',function(){ addP(ph.files); ph.value=''; });
  var pd=$('[data-pdrop]');
  ['dragenter','dragover'].forEach(function(ev){ pd.addEventListener(ev,function(e){ e.preventDefault(); pd.classList.add('is-over'); }); });
  ['dragleave','drop'].forEach(function(ev){ pd.addEventListener(ev,function(e){ e.preventDefault(); pd.classList.remove('is-over'); }); });
  pd.addEventListener('drop',function(e){ if(e.dataTransfer) addP(e.dataTransfer.files); });
  // il modulo dell'OS prende al massimo 5 allegati: oltre i 5 le foto partono in un unico ZIP (senza compressione),
  // con i nomi 1-sopra.jpg ... 6-sotto.jpg e poi 7-... per gli altri file; le immagini grandi si rimpiccioliscono a 3000 px se lo ZIP supera i 25 MB
  var CRC=(function(){ var t=[],c,n,k; for(n=0;n<256;n++){ c=n; for(k=0;k<8;k++) c=c&1?0xEDB88320^(c>>>1):c>>>1; t[n]=c>>>0; } return t; })();
  function crc32(u){ var c=-1; for(var i=0;i<u.length;i++) c=CRC[(c^u[i])&255]^(c>>>8); return (c^-1)>>>0; }
  function zip(items){
    var parts=[], cen=[], off=0, enc=new TextEncoder();
    items.forEach(function(it){
      var nm=enc.encode(it.n), d=it.d, c=crc32(d), h=new DataView(new ArrayBuffer(30));
      h.setUint32(0,0x04034b50,true); h.setUint16(4,20,true); h.setUint16(8,0,true); h.setUint32(14,c,true); h.setUint32(18,d.length,true); h.setUint32(22,d.length,true); h.setUint16(26,nm.length,true);
      parts.push(h,nm,d);
      var e=new DataView(new ArrayBuffer(46));
      e.setUint32(0,0x02014b50,true); e.setUint16(4,20,true); e.setUint16(6,20,true); e.setUint32(16,c,true); e.setUint32(20,d.length,true); e.setUint32(24,d.length,true); e.setUint16(28,nm.length,true); e.setUint32(42,off,true);
      cen.push(e,nm); off+=30+nm.length+d.length;
    });
    var size=cen.reduce(function(a,x){ return a+x.byteLength; },0), z=new DataView(new ArrayBuffer(22));
    z.setUint32(0,0x06054b50,true); z.setUint16(8,items.length,true); z.setUint16(10,items.length,true); z.setUint32(12,size,true); z.setUint32(16,off,true);
    return new Blob(parts.concat(cen,[z]),{type:'application/zip'});
  }
  function small(x){
    if(!/\.(jpe?g|png|webp|heic)$/i.test(x.name)||x.size<1.5*1024*1024) return Promise.resolve(x);
    return new Promise(function(ok){
      var u=URL.createObjectURL(x), im=new Image();
      im.onload=function(){ var k=Math.min(1,3000/Math.max(im.naturalWidth,im.naturalHeight)), c=document.createElement('canvas');
        c.width=Math.round(im.naturalWidth*k); c.height=Math.round(im.naturalHeight*k); c.getContext('2d').drawImage(im,0,0,c.width,c.height); URL.revokeObjectURL(u);
        c.toBlob(function(b){ ok(b&&b.size<x.size?new File([b],x.name.replace(/\.\w+$/,'.jpg'),{type:'image/jpeg'}):x); },'image/jpeg',.9); };
      im.onerror=function(){ URL.revokeObjectURL(u); ok(x); };   // HEIC fuori da Safari: resta com'e'
      im.src=u;
    });
  }
  var MAXB=25*1024*1024;
  function pacchetto(fl){
    if(fl.length<=5) return Promise.resolve(fl);
    var tot=fl.reduce(function(a,x){ return a+x.size; },0);
    return (tot>MAXB-fl.length*200?Promise.all(fl.map(small)):Promise.resolve(fl)).then(function(fs){
      return Promise.all(fs.map(function(x){ return x.arrayBuffer(); })).then(function(bufs){
        var b=zip(fs.map(function(x,i){ return {n:x.name,d:new Uint8Array(bufs[i])}; }));
        if(b.size>MAXB) throw new Error(T.n_big);
        return [new File([b],'foto-pezzo.zip',{type:'application/zip'})];
      });
    });
  }
  nff.addEventListener('submit',function(e){
    e.preventDefault();
    if(!nff.checkValidity()){ nff.reportValidity(); return; }
    var d=new FormData(nff), m=nff.querySelector('[data-fmsg]'), btn=nff.querySelector('[data-send]'), lbl=btn.textContent;
    var tutti=[];
    sfiles.forEach(function(x,i){ if(x) tutti.push(new File([x],(i+1)+'-'+SLUG[i]+(x.name.match(/\.\w+$/)||['.jpg'])[0].toLowerCase(),{type:x.type})); });
    pfiles.forEach(function(x,i){ tutti.push(new File([x],(7+i)+'-'+x.name.replace(/[^A-Za-z0-9._-]+/g,'_'),{type:x.type})); });
    var viste=SLUG.map(function(n,i){ return (i+1)+' '+n+': '+(sfiles[i]?'si\'':'manca'); }).join(' | ');
    if(tutti.length>5){ btn.disabled=true; btn.textContent=T.n_zip; }
    pacchetto(tutti).then(function(fl){ btn.disabled=false; btn.textContent=lbl; invia(nff,fl,{prodotto:String(d.get('prodotto')||''),quantita:String(d.get('quantita')||'1'),finitura:String(d.get('mat')||'')},function(d){
      var mis=['l','w','h'].map(function(x){return String(d.get(x)||'').trim()||'?';});
      return ['STAMPA 3D SENZA FILE: da disegnare (dal sito)','Pezzo: '+d.get('prodotto'),'Misure (mm): '+mis.join(' x '),
        'Pezzo originale: '+(d.get('pezzo')||'-'),'Materiale: '+(d.get('mat')||'da consigliare'),'Quantita\': '+(d.get('quantita')||1),
        '','Dove va e cosa deve sopportare:',String(d.get('uso')||'-'),'','Viste: '+viste,'Foto/file allegati: '+tutti.length+(tutti.length>5?' (in foto-pezzo.zip)':'')].join('\n');
    },'stampa3d_disegno'); }).catch(function(err){ btn.disabled=false; btn.textContent=lbl; m.hidden=false; m.className='es3__msg is-err'; m.textContent=(err&&err.message)||T.f_err; });
  });
})();
